import React, { useLayoutEffect, useState } from "react";
import { Block } from "thorium-ui";

export const ProjectCard = (props) => {
   const [imgDir, setImgDir] = useState(null);
   useLayoutEffect(() => {
      const lazyLoadImage = async () => {
         const logo = await import(`../../assets/images/thumbs/${props.thumb}`)
            .then((data) => {
               return data.default;
            })
            .catch((e) => console.error(e));
         setImgDir(logo);
      };
      lazyLoadImage();
   }, [props.thumb]);

   return (
      <Block
         xs={12}
         sm={12}
         md={6}
         lg={6}
         xl={4}
         className="project-card-container animate fade expandY"
      >
         <div
            className="project-card-image"
            style={{ backgroundImage: `url('${imgDir}')` }}
         />

         <div className="project-card-overlay">
            <div className="project-card-links-container">
               {props.URL && (
                  <a
                     href={`${props.URL}`}
                     rel="noopener noreferrer"
                     target="_blank"
                     className="project-card-link"
                  >
                     View Project
                  </a>
               )}
               <a
                  href={`${props.github}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="project-card-link"
               >
                  View Code
               </a>
            </div>
         </div>
      </Block>
   );
};

export default ProjectCard;
